import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		width: '100%',
		height: '100%',
		// React Flow measures the immediate parent element.
		// `min-height` is critical here because some parent layouts in the app use
		// auto heights + flex, where children can temporarily resolve to 0px.
		minHeight: 650,
		position: 'relative',
	},
});
